import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getData, postData } from "../../Service/ApiMethod";
import { HIRE, Recruiter_Profile_Status, vaccancy_url } from "../../Service/service";
import BackBar from "../home/BackBar";
import Calendar from "react-calendar";
import '../../../node_modules/react-calendar/dist/Calendar.css'
import AddToList from "./AddToList";
// import HireBox from "./HireBox";
import { useTranslation } from "react-i18next";


const Applicant_hiring = () => {

  const [vaccancies, setVacancies] = useState()
  const [vacancyID, setVacancyID] = useState(0)
  const [recruiterID, setRecruiterID] = useState(0)
  const [date, setDate] = useState(new Date())
  const [popup, setPopup] = useState(false)
  // const [unlockUser, setUnlockedUser] = useState({})
  const location = useLocation()
  const navigate = useNavigate()

  const locationData = location?.state?.item


  console.log(' location Dataa',  locationData)


  const seeker_ID = Number(locationData?.user)

  let fromdate = date && date[0]
  let todate = date && date[1]

  const handleVacancy = () => {
    getData(vaccancy_url+"?pgNo="+1+"&keyword=")
      .then(res => res.json())
      .then(data => {
        console.log("VacnacyData", data.data)
        setVacancies(data.data.vacancy) 
      })
  }

  const handleRecruiterID = () => {
    getData(Recruiter_Profile_Status)
      .then(res => res.json())
      .then(data => {
        console.log("RecruiterProfileStatus", data.data)
        setRecruiterID(data.data?.user?.id)
      })
  }

  console.log('location', location?.state?.item)
  console.log('vaccancies', vaccancies)
  console.log('recruiterID', recruiterID)
  console.log('location Data', locationData)
  console.log('seeker_ID', seeker_ID)
  console.log('date', date)
  console.log('date[0]', date[0])
  console.log('date[1]', date[1])
  console.log('fromdate', fromdate)
  console.log('todate', todate)

  var today = new Date()
  console.log('today before edit', today)
  var dd = String(today?.getDate())?.padStart(2, 0);
  var mm = String(today?.getMonth() + 1)?.padStart(2, 0);
  // var mm = monthNames[today?.getMonth()]
  var yyyy = today?.getFullYear();
  today = yyyy + '-' + mm + '-' + dd
  console.log('today after edit', today)

  console.log('date[0] before edit', fromdate)
  var de = String(fromdate?.getDate())?.padStart(2, 0);
  var mn = String(fromdate?.getMonth() + 1)?.padStart(2, 0);
  // var mm = monthNames[today?.getMonth()]
  var year = fromdate?.getFullYear();
  fromdate = year + '-' + mn + '-' + de
  console.log('date[0] after edit', fromdate)


  console.log('date[1] before edit', todate)
  // console.log('date toDateString', date.toDateString())
  var d = String(todate?.getDate())?.padStart(2, 0);
  var m = String(todate?.getMonth() + 1)?.padStart(2, 0);
  // var m = monthNames[date?.getMonth()]
  var y = todate?.getFullYear();
  todate = y + '-' + m + '-' + d
  console.log('date[1] after edit', todate)

  const objSelectHireData = {
    "seeker": seeker_ID,
    "vacancy": vacancyID,
    "recruiter": recruiterID,
    // "from_date": fromDate,
    "from_date": fromdate,
    // "to_date": toDate,
    "to_date": todate,
    "hire_date": today,
    "hours_worked": 0
  }

  const handleVacancyID = (id) => {
    setVacancyID(id)
  }

  console.log('vacancyID', vacancyID)

  // const handleGetDate = (e) => {
  //   const selectedDate = yyyy + '-' + mm + '-' + e.target.textContent
  //   console.log('date', selectedDate)
  //   if (!fromDate) {
  //     setFromDate(selectedDate)
  //   } else {
  //     setToDate(selectedDate)
  //   }
  // }

  console.log('fromDate', fromdate)
  console.log('toDate', todate)



  const handleSelectedHire = () => {
console.log("ddddddd")
   if (!vacancyID) {
      alert("Please Select Vacancy");
    } else if (fromdate == todate) {
      alert("Please Select date range");
    } else if (!fromdate) {
      alert("Plaese Select Job Duration ");
    } else if (!todate) {
      alert("Plaese Select Job Duration ");
    }  else if (seeker_ID && vacancyID && recruiterID && (fromdate != todate)) {
      console.log("checkkk",vacancyID,fromdate == todate,!fromdate,!todate,recruiterID)
      postData(objSelectHireData, HIRE)
        .then(res => res.json())
        .then(data => {console.log("datahire", data)
        alert(data?.message)
        navigate('/home')
      })
        .catch((error) => {
          console.log(error.message)
        })
    }else{
      console.log("checkkk",vacancyID,fromdate , todate,fromdate,!todate,recruiterID)
    }
    // else {
    //   alert('Please fill the required fileds')
    // }
  }

  useEffect(() => {
    handleVacancy()
    handleRecruiterID()
  }, [])

  const {t} = useTranslation()

  return (
    <>
      <BackBar title={t("Hiring Details")} />
      <div className="flex-center">
        <div className="recommended-profile cnadidate-profule pb-2">
          <div className="row">
            <div className=" col-md-1 col-sm-12 px-0 flex-center p-2">
              <div className="vaccancy-pic-area-profile">
              <img src={locationData?.image} alt="" className="profile-img" width='' height='' />
              {/* <div className="view-profile horizontal-center">
                <span className="view-profile-link">View Full Profile</span>
              </div> */}
            </div>
            </div>
            <div className=" col-md-11 col-sm-12  mt-1 flex-column d-flex justify-content-center">
              <h2 className="card-heding relative">
                {/* {(locationData?.first_name || locationData?.candidate[0]?.first_name) ? (locationData?.first_name || unlockedCandiadte?.candidate[0]?.first_name) : 'Unknown'} {(locationData?.last_name || unlockedCandiadte?.candidate[0]?.last_name) ? (locationData?.last_name || unlockedCandiadte?.candidate[0]?.last_name) : ''} */}
                {(locationData?.first_name) ?? 'unknown'} {(locationData?.last_name)}
                <img
                  src="./images/send-job.png"
                  style={{}}
                  alt=""
                  className="addprofile"
                  onClick={()=>setPopup(true)}
                />
              </h2>
              <p
                className="hired-designation"
              >
                {locationData?.profile_title}
              </p>
              <div className="row mt-1">
                <div className="col-6 px-0">
                  <p
                    className="card-subHeading"
                  >
                    {t('Total Experience')}
                  </p>
                </div>
                <div className="col-6 px-0">
                <p className="profile-info">
                  <span>
                    {locationData?.total_experience} {locationData?.total_experience>1?'Years':'Year'}
                 </span>
                 <span>

                 </span>
                </p>


                </div>
                <div className="col-6 px-0">
                  <p
                    className="card-subHeading"
                  >
                    {t('Current Location')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="profile-info"
                  >
                    {parseInt(locationData?.distance)} {t('KM Away')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p
                    className="card-subHeading"
                  >
                    {t('Package')}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p className="profile-info" >
                {locationData?.currency} {locationData?.expected_salary} {locationData?.compensation_details}
                  </p>
                </div>
                <div className="col-6 px-0">
                  <p className="horizontal-center">
                    <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt="hi"
                    />
                    <span className="ms-1 match-profile">
                {parseInt(locationData?.percentage_match)}% {t('Match')}
                    </span>
                  </p>
                </div>
                <div className="col-12 px-0">
                  <p className="profile-last-seen">
                    <span className="last-seen">{t('last Seen')}</span>
                    <span style={{color:'blue'}}>{locationData?.last_active} {t('ago')}</span>
                  </p>
                </div>
              </div>
              <hr className="blue-line-bottom" />
              <hr className="blue-line" />
            </div>
          </div>
        </div>
      </div>
      <p className="my-2 popup-heading p-2">{t('Vacancy Details')}</p>
      <select
        id="cars"
        className="input-select mb-2  m-2"
        placeholder="Select Job Category *"
        onChange={(e) => handleVacancyID(e.target.value)}
      >
        <option value="0">{t('Select Job Category *')}</option>
        {vaccancies?.map((item) =>
          <option key={item.id} value={item.id} >{item.title}</option>
        )}
      </select>

      <p className="my-2 popup-heading p-2">Job Duration</p>
      <div className='job-duration flex-center p-2'  >
        <Calendar calendarStyle={{width:'100px'}} onChange={setDate} value={date} selectRange={true} minDate={new Date()} />

      </div>
      < div className="flex-center" >
        <button className="theme-btn px-5 my-3" onClick={handleSelectedHire}>{t('Submit')}</button>
      </div>
      {popup && <AddToList setPopup={setPopup} seekerID={seeker_ID} />}
    </>
  );
};

export default Applicant_hiring;
